import { MapSearchInput } from '../../../shared/utils/queryUtils'

export const subscriptionTableFields: MapSearchInput['path'] = {
    name: ['owner.id']
}
